import { Badge } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { statusColor, isTaskOverdue } from '../../utils/complianceFormatters';

/**
 * A task's status in words, the same on every surface (polish pass, 2026-10-28). The dashboard and the task page used
 * to print the stored code ("pending", lowercase, untranslated) while the list said "Overdue" for the same task.
 */
export default function TaskStatusBadge({ task, size }: { task: { status: string; dueDate: string }; size?: 'medium' | 'large' }) {
  const { t } = useTranslation();
  const overdue = isTaskOverdue(task);
  return (
    <Badge appearance="filled" size={size} color={overdue ? 'danger' : statusColor(task.status)} data-testid="task-status-badge">
      {t(`tasksPage.status.${overdue ? 'overdue' : task.status}`)}
    </Badge>
  );
}
